import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Modal, Button, Row, Col, Icon, Tooltip } from 'antd';
@inject('ecodeOrderStore')
@observer
class App extends React.Component {
  onCancel = () => {
    const { onCancel } = this.props;
    onCancel && typeof onCancel === 'function' && onCancel();
  }
  getListInfo = (key, value) => {
    
  }
  render() {
    const { formPrefixCls, visible } = this.props;
    let { ecodeOrderStore: { detail } } = this.props;
    detail = toJS(detail);
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    let detailKeys = [
      { key: 'id', name: '订单id' },
      { key: 'demoId', name: '应用id' },
      { key: 'appId', name: 'appId' },
      { key: 'appName', name: '应用名称' },
      { key: 'applyType', name: '授权类型' },
      { key: 'applyStatus', name: '订单状态' },
      { key: 'applySource', name: '申请来源' },
      { key: 'applicantName', name: '申请人' },
      { key: 'applicantDepart', name: '申请人部门' },
      { key: 'customerId', name: '客户id' },
      { key: 'customerName', name: '客户名称' },
      { key: 'orderNumber', name: '订单号' },
      { key: 'license', name: 'license' },
      { key: ['createDate','createTime'], name: '申请时间' },
      { key: ['modifyDate','modifyTime'], name: '审核时间' },
      { key: 'requestId', name: '审批流程id' }
    ];
    const labelColXs = formItemLayout.labelCol.xs;
    const labelColSm = formItemLayout.labelCol.sm;
    const wrapperColXs = formItemLayout.wrapperCol.xs;
    const wrapperColSm = formItemLayout.wrapperCol.sm;
    return (
      <Modal
        title={'案例信息'}
        visible={visible}
        onCancel={this.onCancel}
        width={950}
        zIndex={1000}
        footer={
          [(<Button onClick={this.onCancel} key="detailCancel">返回</Button>)]
        }
      >
        <Row className={`${formPrefixCls}-row`}>
          {
            detailKeys && detailKeys.map((item) => {
              let content = ''
              if (typeof item.key === 'string') {
                content = detail[item.key];
                if (item.render) content = item.render(detail);
              } else {
                content = item.key.map((k) => `${detail[k]} `);
              }
              const otherParams = item.textElli ? { title: content } : {};
              return (
                <Col span={item.singleLine ? 24 : 12} key={item.key}>
                  <Row>
                    <Col xs={labelColXs} sm={item.singleLine ? { span: labelColSm.span / 2 } : labelColSm}>
                      <div className="sys-ecode-detail-label">{item.name}</div>
                    </Col>
                    <Col xs={wrapperColXs} sm={item.singleLine ? { span: 24 - (labelColSm.span / 2) } : wrapperColSm}>
                      <div className={`sys-ecode-detail-wrapper${item.singleLine ? '-mul' : ''} ${item.textElli && 'text-elli'}`} {...otherParams}>
                        { content }
                      </div>
                    </Col>
                  </Row>
                </Col>
            )})
          }
        </Row>
      </Modal>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/order/Detail.js